import { render, staticRenderFns } from "./payment-link.vue?vue&type=template&id=b4bb7f90"
import script from "./payment-link.vue?vue&type=script&lang=js"
export * from "./payment-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports